import React, { useRef, useState } from 'react';
import { Popup } from '../../components/Popup';
import { Button } from '../../components/Button';
import { useDispatch, useSelector } from 'react-redux';
import { Input } from '../../components/Input';
import { validateCreatePromoter } from '../../helpers';
import { PhoneInput } from '../../components/Input/PhoneInput';
import { CLIENT_NOTS, getClientNotify } from '../../redux/notifySlice';
import { createPromoter, deletePromoter, editPromoter, Promoter, recoveryPromoter } from '../../redux/advertSlice';
import { Select } from '../../components/Select';

export const CreatePromoter = ({ closeFn, curPromoter:prom }) => {
    const dispatch = useDispatch();
    const advertCities = useSelector((state) => state.settings.advertCities);
    const advertSources = useSelector((state) => state.settings.advertSources).filter(s => s.isPrimary);

    const referalList = useSelector((state) => state.advert.promoters).map(p => ({_id: p._id, name: p.fullname}))

    const isCreate = !prom;
    
    const [files, setFiles] = useState([]);

    const setFilesHandler = (e) => {
        const selectedFiles = Array.from(e.target.files);
        setFiles(selectedFiles);
    };
    const clickInputHandler = () => {
        fileInputRef.current.click();
    };
    const fileInputRef = useRef(null);

    const [telegramId, setTelegramId] = useState(prom?.telegramId || '');
    const [id, setId] = useState(prom?.id || '');
    const [fullname, setFullname] = useState(prom?.fullname || '');
    const [phone, setPhone] = useState(prom?.phoneNumber || '');
    const [age, setAge] = useState(prom?.age || 16);
    const [bet, setBet] = useState(prom?.bet || 0.35);
    const [isFullReport, setFullReport] = useState(prom ? prom.isFullReport : true);
    const [city, setCity] = useState(prom?.city?._id || advertCities[0]?._id);
    const [sourceType, setSourceType] = useState(prom?.sourceType._id || advertSources[0]?._id);
    const [invitedBy, setInvitedBy] = useState(prom?.invitedBy?._id || referalList[0]?._id || 'null')
    const [paymentDetails, setPaymentDetails] = useState(prom?.paymentDetails || '');
    const [keyStatus, setKeyStatus] = useState(prom ? prom.keyStatus : -1);
    const [keyStatus2, setKeyStatus2] = useState(prom ? prom.keyStatus2 : -1);
    
    const isReferralSourceType = advertSources.find(s => s._id === sourceType)?.name === 'Реферал';

    const saveHandler = () => {
        const body = {
            telegramId: +telegramId,
            id: +id,
            bet: +bet,
            city,
            sourceType,
            invitedBy: isReferralSourceType ? invitedBy : null,
            isFullReport,
            fullname,
            phoneNumber: phone,
            age: +age,
            keyStatus,
            keyStatus2: keyStatus === -1 ? -1 : keyStatus2,
            paymentDetails,
            files
        }
        const validateResult = validateCreatePromoter(body);
        if (!validateResult.isOkay) {
            dispatch(getClientNotify({
                data: validateResult,
                action: CLIENT_NOTS.EMPTY_FIELD,
            }));
            return;
        }
        if (isCreate) {
            delete body.keyStatus2;
            dispatch(createPromoter({promoterData: body, resetFunc: closeFn}))
            return;
        }
        body._id = prom._id;
        dispatch(editPromoter({promoterData: body, resetFunc: closeFn}))
    };
    const deleteHandler = () => {
        dispatch(deletePromoter({promoterId: prom._id, resetFunc: closeFn}))
    }
    const recoveryHandler = () => {
        dispatch(recoveryPromoter({promoterId: prom._id, resetFunc: closeFn}))
    }
    const promoterPopupButtons = isCreate ?
    <Button text={`Создать`} onClick={saveHandler} />
    : <>
        <Button text={`Сохранить`} onClick={saveHandler} />
        <Button text={!prom.deleted ? 'Удалить':'Восстановить'} onClick={!prom.deleted ? deleteHandler : recoveryHandler} />
    </>

    return (
        <Popup
            title={isCreate ? `Создание промоутера` : 'Редактировать промоутера'}
            closeFn={closeFn}
            closeWithOutsideClick={false}
            button={promoterPopupButtons}>
            <form className="promoter__create-popup promoter-popup">
                <div className="promoter-popup__row">
                    <div className="promoter-popup__col">
                        <Input min={0} type='number' label="Отображаемый id" value={id} changeHandler={(e) => setId(e.target.value)} required={true} />
                    </div>
                    <div className="promoter-popup__col">
                        <Input min={0} type='number' label="telegramId" value={telegramId} changeHandler={(e) => setTelegramId(e.target.value)} required />
                    </div>
                </div>
                <div className="promoter-popup__row">
                    <div className="promoter-popup__col">
                        <Input label="Полное имя" value={fullname} changeHandler={(e) => setFullname(e.target.value)} required />
                    </div>
                    <div className="promoter-popup__col">
                        <Input min={0} type='number' label="Возраст" value={age} changeHandler={(e) => setAge(e.target.value)} required />
                    </div>
                </div>
                <div className="promoter-popup__row">
                    <div className="promoter-popup__col">
                        <label className='input__label'>Телефон
                            <PhoneInput value={phone} changeHandler={(e) => setPhone(e.target.value)} required />
                        </label>
                    </div>
                    <div className="promoter-popup__col" style={{alignSelf: 'flex-end'}}>
                        <input
                            accept=".jpg,.jpeg,.png"
                            style={{ display: 'none' }}
                            ref={fileInputRef}
                            type="file"
                            multiple={true}
                            onChange={setFilesHandler}
                        />
                        <Button text={files.length ? `Выбрано ${files.length} фото` : 'Прикрепить документы'} onClick={clickInputHandler}/>
                        {!!files.length && <span style={{marginLeft: '6px'}} className='span-button' onClick={() => setFiles([])}>Сброс</span>}
                    </div>
                </div>
                <div className="promoter-popup__row">
                    <div className="promoter-popup__col">
                        <Input min={0} step={0.01} type='number' label="Ставка" value={bet} changeHandler={(e) => setBet(e.target.value)} required={true} />
                    </div>
                    <div className="promoter-popup__col radio">
                        <label><input type="radio" checked={!isFullReport} onChange={() => setFullReport(prev => !prev)} />Фото отчет</label>
                        <label><input type="radio" checked={isFullReport} onChange={() => setFullReport(prev => !prev)} />Полный отчет</label>
                    </div>
                </div>
                <div className='promoter-popup__row'>
                    <div className='promoter-popup__col'>
                        <Select label='Город' enums={advertCities} value={city} changeHandler={(e) => setCity(e.target.value)}/>
                    </div>
                    <div className='promoter-popup__col'>
                    <Input label="Реквизиты для оплаты" placeholder='Можно оставить пустым' value={paymentDetails} changeHandler={(e) => setPaymentDetails(e.target.value)} required={true} />
                    </div>
                </div>
                <div className="promoter-popup__row full">
                    <h4>Ключи</h4>
                    <div className="promoter-popup__col full">
                        <label><input type="radio" checked={keyStatus === -1} onChange={() => setKeyStatus(-1)} />Не выданы</label>
                        <label><input type="radio" checked={keyStatus === 0} onChange={() => setKeyStatus(0)} />Под залог</label>
                        <label><input type="radio" checked={keyStatus === 1} onChange={() => setKeyStatus(1)} />Удержание с зп</label>
                    </div>
                    {keyStatus !== -1 && !isCreate && <div className="promoter-popup__col full">
                        <label><input type="radio" checked={keyStatus2 === 0} onChange={() => setKeyStatus2(0)} />У прома</label>
                        <label><input type="radio" checked={keyStatus2 === 1} onChange={() => setKeyStatus2(1)} />В офисе</label>
                        <label><input type="radio" checked={keyStatus2 === 2} onChange={() => setKeyStatus2(2)} />Вернул</label>
                        <label><input type="radio" checked={keyStatus2 === 3} onChange={() => setKeyStatus2(3)} />Украл</label>
                    </div>}
                </div>
                <div className={`promoter-popup__row ${!isReferralSourceType ? 'full':''}`}>
                    <div className={`promoter-popup__col ${!isReferralSourceType ? 'full':''}`}>
                        <Select label='Источник' enums={advertSources} value={sourceType} changeHandler={(e) => setSourceType(e.target.value)}/>
                    </div>
                    {isReferralSourceType && <div className={`promoter-popup__col ${!isReferralSourceType ? 'full':''}`}>
                        <Select label='Кто привёл' enums={referalList} value={invitedBy} changeHandler={(e) => setInvitedBy(e.target.value)}/>
                    </div>}
                </div>
            </form>
        </Popup>
    );
};
